// Where a user object comes from, as the backend reports it in `origin`; older payloads
// without it fall back to data.source.
export const ORIGIN_LOCAL = 'local';
export const ORIGIN_ENTRA_ID = 'entra_id';
export const ORIGIN_BE_ACTIVE = 'be_active';

const LABELS = {
  [ORIGIN_LOCAL]: 'Local',
  [ORIGIN_ENTRA_ID]: 'Entra ID',
  [ORIGIN_BE_ACTIVE]: 'BeActive',
};

export const userOrigin = (user) => {
  if (user?.origin) return user.origin;
  const sources = user?.data?.source || [];
  if (sources.includes('Azure')) return ORIGIN_ENTRA_ID;
  if (sources.includes('BeActive')) return ORIGIN_BE_ACTIVE;
  return ORIGIN_LOCAL;
};

export const isImportedUser = (user) => userOrigin(user) !== ORIGIN_LOCAL;

export const userNameWithOrigin = (user) =>
  `${user?.name || ''} (${LABELS[userOrigin(user)]})`;
